// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"a8","reportCardBox":"a8","report-img-wrap":"a9","reportImgWrap":"a9","report-title":"a-","reportTitle":"a-","report-date":"a_","reportDate":"a_"};